/* eslint-disable formatjs/no-literal-string-in-jsx -- Temporary placeholder; MEM-353 will replace this with the real article view. */
import React from "react"
import { useFlags } from "launchdarkly-react-client-sdk"
import { Redirect, useParams } from "react-router-dom"
import { GetHelpIcon, Typography } from "@carrotfertility/carotene-core"
import { PageHeader } from "#/features/global-ui/page-header"
import { PageLayout } from "#/features/global-ui/page-layout"
import { Title } from "#/services/page-title/Title"
import { Paths } from "#/utils/Paths"
import { parseArticleIdFromPath } from "#/services/help-center/urls"

export function FaqsArticlePlaceholder(): JSX.Element {
  const { contentfulHelpCenter } = useFlags()

  if (!contentfulHelpCenter) {
    return <Redirect to="/" />
  }

  return <FaqsArticlePlaceholderContent />
}

function FaqsArticlePlaceholderContent(): JSX.Element {
  const { vanityAndId } = useParams<{ vanityAndId: string }>()
  const articleId = parseArticleIdFromPath(vanityAndId)

  if (!articleId) {
    return <Redirect to={Paths.FAQS} />
  }

  return (
    <>
      <Title title="Article" productTitle="FAQs" />
      <PageLayout
        header={
          <PageHeader
            startGlyph={<GetHelpIcon sx={{ blockSize: "2.25rem", inlineSize: "2.25rem" }} />}
            pageTitle="Article"
          />
        }
      >
        <Typography variant="body1">Article rendering is coming soon.</Typography>
        <Typography variant="body2" color={(theme) => theme.palette.text.tertiary}>
          Article id: {articleId}
        </Typography>
      </PageLayout>
    </>
  )
}
/* eslint-enable formatjs/no-literal-string-in-jsx */
